import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {
  status: string = '';
  error: string = '';

  constructor(
    public dialog: MatDialogRef<AlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.status = data.status;
    this.error = data.error;
  }

  ngOnInit() {}

  onNoClick() {
    this.dialog.close();
  }

  Close() {
    this.dialog.close();
  }
}
